"use client";

import { useEffect } from "react";
import { useConquistasSupabase } from "../hooks/use-conquistas-supabase";

export function ConquistaListener() {
  const { criarConquista } = useConquistasSupabase();

  useEffect(() => {
    const handlePublicarConquista = async (event: Event) => {
      const customEvent = event as CustomEvent;
      const { tarefaId, titulo, descricao, tipo } = customEvent.detail;
      console.log('Evento publicarConquista recebido no listener global:', { tarefaId, titulo, descricao, tipo });
      const resultado = await criarConquista({
        titulo,
        descricao: descricao || '',
        tipo: tipo as 'tarefa' | 'epico' | 'iniciativa',
        tarefa_id: tarefaId
      });
      console.log('Resultado de criarConquista no listener global:', resultado);

      // Enviar notificação nativa do sistema
      if (resultado && 'Notification' in window) {
        try {
          // Solicitar permissão se ainda não tiver
          if (Notification.permission === 'default') {
            await Notification.requestPermission();
          }

          // Enviar notificação se tiver permissão
          if (Notification.permission === 'granted') {
            new Notification('🏆 Conquista Compartilhada!', {
              body: `${titulo}${descricao ? ': ' + descricao : ''}`,
              icon: '/icon-192.svg',
              badge: '/icon-192.svg',
              tag: `conquista-${resultado.id}`,
              requireInteraction: false,
              silent: false
            });
          }
        } catch (error) {
          console.error('Erro ao enviar notificação nativa:', error);
        }
      }

      // Disparar evento para recarregar o feed
      window.dispatchEvent(new CustomEvent('conquistaCriada'));
    };

    window.addEventListener('publicarConquista', handlePublicarConquista);

    return () => {
      window.removeEventListener('publicarConquista', handlePublicarConquista);
    };
  }, [criarConquista]);

  return null;
}
